// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"i3-z","dimensionLabel":"j3-z","styleChooserControlWrapper":"k3-z","styleChooserControl":"l3-z","disabled":"m3-z","giftCard":"n3-z","styleChooserText":"o3-z"};